module.exports = __webpack_public_path__ + "static/media/roadtripmarkericon.6f0c968a.ico";